import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';

/** Read-only cliente (misma idea que `dinoc/viewProject/client`). */
const Client = ({ values, companyName }) => {
  const company =
    companyName !== undefined && companyName !== null && companyName !== ''
      ? companyName
      : get(values, 'data.companyName', '');

  return (
    <>
      <div className="row">
        <div className="col-12 ViewOrEdit">
          <div>
            <strong>
              <FormattedMessage id="Nombre:" />
            </strong>
            <span>{get(values, 'customer.firstname', '-')}</span>
          </div>
          <div className="kt-space-20" />
          <div>
            <strong>
              <FormattedMessage id="Correo electronico:" />
            </strong>
            <span>{get(values, 'customer.email', '-')}</span>
          </div>
          {company ? (
            <>
              <div className="kt-space-20" />
              <div>
                <strong>
                  <FormattedMessage id="Empresa / Razon social" />
                </strong>
                <span>{company}</span>
              </div>
            </>
          ) : null}
          {get(values, 'customer.state') ? (
            <>
              <div className="kt-space-20" />
              <div>
                <strong>
                  <FormattedMessage id="Provincia:" />
                </strong>
                <span>{get(values, 'customer.state', '-')}</span>
              </div>
            </>
          ) : null}
        </div>
      </div>
      <div className="col-12">
        <div className="kt-space-20" />
      </div>
    </>
  );
};

export default Client;
